<template>
  <v-alert
    prominent
    dismissible
    text
    transition="scale-transition"
    v-if="alert?.status"
    dense
    border="left"
    :type="alert?.status === 'success' ? 'success' : 'error'"
  >
    <template v-slot:close="{}">
      <v-icon @click="$store.commit('SET_ALERT', null)"
        >mdi-close-circle</v-icon
      >
    </template>
    {{ alert?.message }}
  </v-alert>
</template>

<script>
export default {
  name: "Alert",

  mounted() {
    setTimeout(
      this.$store.dispatch("CloseAlert", { status: "", message: "" }),
      5000
    );
  },
  computed: {
    alert() {
      return this.$store.getters["alert"];
    },
  },
};
</script>

<style scoped></style>
